import axios from 'axios';

const API_URL = '/api/medical-history';

export const getMedicalHistory = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching medical history:", error);
        throw error;
    }
};

export const createMedicalHistory = async (historyData) => {
    try {
        const response = await axios.post(API_URL, historyData);
        return response.data;
    } catch (error) {
        console.error("Error creating medical history:", error);
        throw error;
    }
};

export const updateMedicalHistory = async (id, historyData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, historyData);
        return response.data;
    } catch (error) {
        console.error("Error updating medical history:", error);
        throw error;
    }
};

export const deleteMedicalHistory = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting medical history:", error);
        throw error;
    }
};